import React from "react";
import { FaArrowRight, FaBuilding, FaFileAlt, FaRegCalendarCheck, FaUserFriends, FaUsersCog, FaUserTie } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ReportList: React.FC = () => {
  const navigate = useNavigate();

  const gotoReports = (type: string) => {
    navigate(`/${type}`);
  };

  const reportCards = [
    {
      id: 1,
      type: "report",
      title: "Schedule Report",
      icon: FaRegCalendarCheck,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600"
    },
    {
      id: 2,
      type: "interview_report",
      title: "Interview Report",
      icon: FaUserTie,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600"
    },
    {
      id: 3,
      type: "jd_report",
      title: "JD Report",
      icon: FaFileAlt,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600"
    },
    {
      id: 4,
      type: "ta_report",
      title: "TA Report",
      icon: FaUsersCog,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600"
    },
    {
      id: 5,
      type: "client_report",
      title: "Client Report",
      icon: FaBuilding,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600"
    },
    {
      id: 6,
      type: "client_ta_report",
      title: "Client TA Report",
      icon: FaUserFriends,
      color: "from-blue-500 to-blue-600",
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600"
    }
  ];

  return (
    <div className=" py-8 px-4 h-[calc(100vh-100px)]  w-[calc(100vw-120px)] 2xl:w-[calc(100vw-155px)] 2xl:h-[calc(100vh-115px)]">
      <div className="max-w-7xl mx-auto">
        <div className="text-start">
          <p className="text-xl px-10 py-2 font-bold text-gray-800 mb-4">
            Analytics & Reports
          </p>
        </div>

        <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3  p-4 overflow-auto gap-4 px-10">
          {reportCards.map((card) => (
            <div
              key={card.id}
              className="group bg-white rounded-md shadow-sm hover:shadow-md transition-all duration-100 transform  cursor-pointer border border-gray-100 overflow-hidden"
              onClick={() => gotoReports(card.type)}
            >
              <div className="p-6">
                <div className={`inline-flex items-center justify-center p-4 rounded-md ${card.bgColor} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <card.icon className={`text-2xl ${card.iconColor}`} />
                </div>
                <div className="flex justify-between items-center">
                  <h3 className="text-md font-semibold text-gray-600  group-hover:text-gray-900 transition-colors">
                    {card.title}
                  </h3>
                  <div className="flex items-center text-sm font-medium text-gray-600 group-hover:text-gray-800 transition-colors">
                    <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" />
                  </div>
                </div>
              </div>


            </div>
          ))}
        </div>

      
      </div>
    </div>
  );
};

export default ReportList;